module.exports = __webpack_public_path__ + "img/mt.8e35c9d0.svg";